export enum MatchesQueryKeys {
  Suspended = "matches.suspended",
  MarketMatches = "matches.marketMatches",
  FullMatches = "matches.fullMatches",
  FullMatchesPaginated = "matches.fullMatchesPaginated",
  FullMatchesInfinite = "matches.fullMatchesInfinite",
  Streams = "matches.streams",
  ScoremerTeams = "matches.scoremerTeams",
  ScoremerTeamRaces = "matches.scoremerTeamRaces",
  ScoremerSearchRaces = "matches.scoremerSearchRaces",
}
